<template>
  <el-dialog :visible.sync="visible"
             title="离职历史记录"
             width="900px"
             custom-class="dialog"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              style="width: 100%;">
      <!-- 序号 -->
      <el-table-column prop="tableId"
                       align="center"
                       fixed="left"
                       :label="$t('dimission.dimissionId')"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- 姓名 user_name -->
      <el-table-column prop="userName"
                       align="center"
                       fixed="left"
                       :label="$t('dimission.name')"
                       show-overflow-tooltip
                       width="100">
      </el-table-column>
      <!-- 用户类型 org_type -->
      <el-table-column prop="orgType"
                       align="center"
                       :label="$t('dimission.userType')"
                       :formatter="orgFormatter"
                       show-overflow-tooltip
                       width="100">
      </el-table-column>
      <!-- 性别 sex_code -->
      <el-table-column prop="sexCode"
                       align="center"
                       :label="$t('dimission.sexCode')"
                       :formatter="sexFormatter"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- 工作年限 计算 1年一下 1~3年 3~5年 5~10年 10年以上 当前时间减去离校时间 -->
      <!-- <el-table-column prop="workingYears"
                         align="center"
                         :label="$t('dimission.workingYears')"
                         show-overflow-tooltip>
        </el-table-column> -->
      <!-- 宝龄 单独计算，宝马工龄累计（bmw_seniority）+ 当前时间 - 入职时间（TODO需要跟许确认当前算法） -->
      <el-table-column prop="bmwSeniority"
                       align="center"
                       :label="$t('dimission.bmwSeniority')"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- 职位 job_code -->
      <el-table-column prop="positionName"
                       align="center"
                       :label="$t('dimission.jobCode')"
                       show-overflow-tooltip
                       width="100">
      </el-table-column>
      <!-- 学历 education_code -->
      <el-table-column prop="educationCode"
                       align="center"
                       :label="$t('dimission.educationCode')"
                       :formatter="educationFormatter"
                       show-overflow-tooltip>
      </el-table-column>
      <!-- 加入网点日期 org_join_date -->
      <el-table-column prop="orgJoinDate"
                       align="center"
                       :label="$t('dimission.orgJoinDate')"
                       :formatter="joinDateFormatter"
                       show-overflow-tooltip
                       width="200">
      </el-table-column>
      <!-- 离职时间 dimission_date -->
      <el-table-column prop="dimissionDate"
                       align="center"
                       :label="$t('dimission.dimissionDate')"
                       :formatter="dimissionDateFormatter"
                       show-overflow-tooltip
                       width="200">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
// import mixinViewModule from '@/mixins/view-module'
export default {
  // mixins: [mixinViewModule],
  data() {
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: '/sys/dimission/list',
        getDataListIsPage: true
      },
      dataForm: {},
      isShow: false,
      dataListLoading: false,
      dataList: [],
      mailId: '',
      visible: false,
      page: 1,
      limit: 10,
      total: 0
    }
  },
  methods: {
    // 性别
    sexFormatter(row) {
      return Vue.filter('coverEnum')(row.sexCode, 'sex')
    },
    // 处理状态
    dimissionStatusFormatter(row) {
      return Vue.filter('coverEnum')(row.dimissionStatus, 'dimissionStatus')
    },
    // 是否加入人才库
    configFormatter(row) {
      return Vue.filter('coverEnum')(row.talentBankFlag, 'confirmState')
    },
    // 用户类型
    orgFormatter(row) {
      return Vue.filter('coverEnum')(row.orgType, 'userType') + '用户'
    },
    // 学历
    educationFormatter(row) {
      return Vue.filter('coverEnum')(row.educationCode, 'educationCode')
    },
    // 格式化时间没有时分秒
    joinDateFormatter(row) {
      if (row.orgJoinDate !== '' && row.orgJoinDate) {
        return Vue.filter('formatDateNoTime')(row.orgJoinDate)
      } else {
        return ''
      }
    },
    // 格式化时间没有时分秒
    dimissionDateFormatter(row) {
      if (row.dimissionDate !== '' && row.dimissionDate) {
        return Vue.filter('formatDateNoTime')(row.dimissionDate)
      } else {
        return ''
      }
    },
    init(id) {
      this.visible = true
      this.dataForm.userId = id
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.result
        for (let i = 0; i < resultList.length; i++) {
          resultList[i]['tableId'] = i + 1
        }
        this.dataList = JSON.parse(JSON.stringify(resultList))
        let todayTime = new Date().getTime()
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].dimissionStatus === '30') {
            this.dataList[i].bmwSeniority = (this.dataList[i].bmwSeniority / 365).toFixed(2)
          } else {
            this.dataList[i].bmwSeniority = ((Number(this.dataList[i].bmwSeniority) + ((todayTime - (new Date(Date.parse(this.dataList[i].currentVersionDate.replace(/-/g, '/'))).getTime())) / 1000 / 60 / 60 / 24)) / 365).toFixed(2)
          }
        }
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      console.log(val)
      this.getDataList()
      console.log(this.dataList)
    }
  }
}
</script>
